import initialState from './initial.state';
import * as types from '../actions/types.action';

export default function upSellingReducer(state = initialState.upSelling, action) {
  switch (action.type) {
    case types.SET_UPSELLING_MODAL_CANCELLED_SUCCESS:
      return Object.assign({}, state, {
        modalCancelled: action.modalCancelled
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/upSelling.reducer.js